import { render, staticRenderFns } from "./admin-managelogo.vue?vue&type=template&id=bde3cb14&"
import script from "./admin-managelogo.vue?vue&type=script&lang=js&"
export * from "./admin-managelogo.vue?vue&type=script&lang=js&"
import style0 from "./admin-managelogo.vue?vue&type=style&index=0&scrope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports